import {
  DARK_PALETTE,
  LIGHT_PALETTE,
  THEME
} from "../../../SComponents/colorPalette.constants";
import { hexToVec3 } from "../../../utils/color";
import { getViewport } from "../viewport/viewport.layer";
import { backgroundGrid } from "./background.graphics";
import { backgroundShader } from "./background.shader";
import * as PIXI from "pixi.js";

/**
 * Redraws the background with appropriate offset adjustments
 * whenever container is resized or the background is dragged.
 *
 * Unsure if setting widths and height everytime would have any
 * performance tradeoffs but not writing any conditional logic
 * to handle those for now.
 * @returns
 */

type RedrawBackgroundProps = {
  position: PIXI.Point;
  scale: number;
};

const tuneables = {
  darkMode: true,
  darkModeDotColor: hexToVec3(DARK_PALETTE.BACKGROUND_DOTS),
  lightModeDotColor: hexToVec3(LIGHT_PALETTE.BACKGROUND_DOTS),
  darkModeBackgroundColor: hexToVec3(DARK_PALETTE.BACKGROUND),
  lightModeBackgroundColor: hexToVec3(LIGHT_PALETTE.BACKGROUND)
};

const redrawBackground = ({ position, scale }: RedrawBackgroundProps) => {
  backgroundGrid.width = window.innerWidth || 0;
  backgroundGrid.height = window.innerHeight || 0;

  const gridSize = 16 * scale;
  const uniforms = {
    offsets: {
      x: position.x % gridSize,
      y: position.y % gridSize
    },
    dotSize: 3 * scale,
    gridSize: gridSize,
    dotColor: tuneables.darkMode
      ? tuneables.darkModeDotColor
      : tuneables.lightModeDotColor,
    backgroundColor: tuneables.darkMode
      ? tuneables.darkModeBackgroundColor
      : tuneables.lightModeBackgroundColor
  };

  backgroundGrid.filters = [new PIXI.Filter("", backgroundShader, uniforms)];
};

export const updateBackground = () => {
  const viewport = getViewport();
  redrawBackground({
    position: viewport.position,
    scale: viewport.scale.x
  });
};

export const setBackgroundTheme = (theme: THEME) => {
  tuneables.darkMode = theme === THEME.DARK;
  updateBackground();
};
